<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="addOrUpdateOffshoreLevel()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <label for="level">{{ 'layout.configurations.offshoreLevel.addOffshoreLevel.level' | translate }} <span class="text-red-600">*</span></label>
    <p-inputNumber
      id="level"
      inputId="integeronly"
      formControlName="level"
      [placeholder]="'layout.configurations.offshoreLevel.addOffshoreLevel.level' | translate"
      styleClass="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('level').invalid }" />
    <div *ngIf="isInvalid('level').invalid" class="text-red-600">{{ isInvalid('level').message | translate }}</div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('level') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="countsAsOffshore">{{ 'layout.configurations.offshoreLevel.addOffshoreLevel.countAsOffshore' | translate }} <span class="text-red-600">*</span></label>
    <div class="flex flex-wrap gap-2">
      <div class="flex align-items-center">
        <p-radioButton formControlName="countsAsOffshore" [value]="true" inputId="yes"></p-radioButton>
        <label for="yes" class="ml-2">{{ 'layout.configurations.offshoreLevel.yes' | translate }}</label>
      </div>
      <div class="flex align-items-center">
        <p-radioButton formControlName="countsAsOffshore" [value]="false" inputId="no"></p-radioButton>
        <label for="no" class="ml-2">{{ 'layout.configurations.offshoreLevel.no' | translate }}</label>
      </div>
    </div>
    <div *ngIf="isInvalid('countsAsOffshore').invalid" class="text-red-600">
      {{ isInvalid('countsAsOffshore').message | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('countsAsOffshore') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="denomination">{{ 'layout.configurations.offshoreLevel.label.DenominationEn' | translate }} <span class="text-red-600">*</span></label>
    <input
      id="denomination"
      formControlName="denomination"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.offshoreLevel.placeholder.DenominationEn' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('denomination').invalid }" />
    <div *ngIf="isInvalid('denomination').invalid" class="text-red-600">
      {{ isInvalid('denomination').message | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('denomination') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="denominationEs">{{ 'layout.configurations.offshoreLevel.label.DenominationEs' | translate }} <span class="text-red-600">*</span></label>
    <input
      id="denominationEs"
      formControlName="denominationEs"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.offshoreLevel.placeholder.DenominationEs' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('denominationEs').invalid }" />
    <div *ngIf="isInvalid('denominationEs').invalid" class="text-red-600">
      {{ isInvalid('denominationEs').message | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('denominationEs') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="denominationAr">{{ 'layout.configurations.offshoreLevel.label.DenominationAr' | translate }} <span class="text-red-600">*</span></label>
    <input
      id="denominationAr"
      formControlName="denominationAr"
      type="text"
      pInputText
      [placeholder]="'layout.configurations.offshoreLevel.placeholder.DenominationAr' | translate"
      class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('denominationAr').invalid }" />
    <div *ngIf="isInvalid('denominationAr').invalid" class="text-red-600">
      {{ isInvalid('denominationAr').message | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('denominationAr') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="definition">{{ 'layout.configurations.offshoreLevel.label.DefinitionEn' | translate }} <span class="text-red-600">*</span></label>
    <textarea 
      id="definition" 
      formControlName="definition" 
      rows="3" 
      class="w-full" 
      pInputTextarea
      [placeholder]="'layout.configurations.offshoreLevel.placeholder.DefinitionEn'| translate"
      [ngClass]="{ 'p-invalid': isInvalid('definition').invalid }">
    </textarea>
    <div *ngIf="isInvalid('definition').invalid" class="text-red-600">
      {{ isInvalid('definition').message | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('definition') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="definitionEs">{{ 'layout.configurations.offshoreLevel.label.DefinitionEs' | translate }} <span class="text-red-600">*</span></label>
    <textarea 
      id="definitionEs" 
      formControlName="definitionEs" 
      rows="3" 
      class="w-full" 
      pInputTextarea
      [placeholder]="'layout.configurations.offshoreLevel.placeholder.DefinitionEs'| translate"
      [ngClass]="{ 'p-invalid': isInvalid('definitionEs').invalid }">
    </textarea>
    <div *ngIf="isInvalid('definitionEs').invalid" class="text-red-600">
      {{ isInvalid('definitionEs').message | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('definitionEs') | translate }}</div>
  </div>
  <div class="flex flex-column gap-2 mb-4">
    <label for="definitionAr">{{ 'layout.configurations.offshoreLevel.label.DefinitionAr' | translate }} <span class="text-red-600">*</span></label>
    <textarea 
      id="definitionAr" 
      formControlName="definitionAr" 
      rows="3" 
      class="w-full" 
      pInputTextarea
      [placeholder]="'layout.configurations.offshoreLevel.placeholder.DefinitionAr'| translate"
      [ngClass]="{ 'p-invalid': isInvalid('definitionAr').invalid }">
    </textarea>
    <div *ngIf="isInvalid('definitionAr').invalid" class="text-red-600">
      {{ isInvalid('definitionAr').message | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('definitionAr') | translate }}</div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4"  *ngIf="!isViewMode">
    <p-button type="submit" icon="pi pi-check" [label]="'layout.configurations.offshoreLevel.addOffshoreLevel.save' | translate"></p-button>
  </div>
</form>